export default __webpack_public_path__ + "static/media/loader_3d_zksync.4b74db0e.gif";